import React from 'react';
export const PauseButton = 
<svg xmlns="http://www.w3.org/2000/svg" 
    width="80" height="80" 
    viewBox="0 0 80 80">
    <path d="M34.125,25h-5.25A0.891,0.891,0,0,0,28,26V54a0.891,0.891,0,0,0,.875,1h5.25A0.891,0.891,0,0,0,35,54V26A0.891,0.891,0,0,0,34.125,25Zm17,0h-5.25A0.891,0.891,0,0,0,45,26V54a0.891,0.891,0,0,0,.875,1h5.25A0.891,0.891,0,0,0,52,54V26A0.891,0.891,0,0,0,51.125,25ZM40,1A39,39,0,1,1,1,40,39.044,39.044,0,0,1,40,1m0-1A40,40,0,1,0,80,40,40,40,0,0,0,40,0h0Z"/>
</svg>